import { http, fallback, createConfig, type CreateConnectorFn } from 'wagmi'
import type { Chain, Transport } from 'viem'
import { bsc, bscTestnet } from 'wagmi/chains'
import { injected, walletConnect } from 'wagmi/connectors'
import { createWeb3Modal } from '@web3modal/wagmi/react'

const projectId = import.meta.env.VITE_WALLET_CONNECT_PROJECT_ID || 'PLACEHOLDER'
const chainEnv = import.meta.env.VITE_CHAIN || (import.meta.env.DEV ? 'localhost' : 'bsc')

const metadata = {
  name: 'USD1 Staking',
  description: 'USD1 Staking Platform',
  url: import.meta.env.VITE_APP_URL || 'http://localhost:3000',
  icons: [],
}

const localhost: Chain = {
  id: 31337,
  name: 'Localhost',
  nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
  rpcUrls: {
    default: { http: ['http://127.0.0.1:8545'] },
  },
}

const bscRpcUrls = (import.meta.env.VITE_BSC_RPC_URLS || 'https://bsc-dataseed.binance.org')
  .split(',')
  .map((s: string) => s.trim())
  .filter(Boolean)

const chainMap: Record<string, { chain: Chain; transport: Transport }> = {
  localhost: { chain: localhost, transport: http('http://127.0.0.1:8545') },
  bscTestnet: { chain: bscTestnet, transport: http() },
  bsc: { chain: bsc, transport: fallback(bscRpcUrls.map((url: string) => http(url))) },
}

const active = chainMap[chainEnv] ?? chainMap.bsc
export const activeChain = active.chain

const chains: [Chain, ...Chain[]] = [active.chain]
const transports: Record<number, Transport> = {
  [active.chain.id]: active.transport,
}

// 始终注册 injected connector，wagmi 在 connect 调用时才检测 provider 是否可用
// EIP-6963 多注入式 provider 发现（默认开启）会自动处理延迟注入的钱包
const connectors: CreateConnectorFn[] = [
  injected(),
  walletConnect({ projectId, metadata, showQrModal: false }),
]

export const wagmiConfig = createConfig({
  chains,
  connectors,
  transports,
})

createWeb3Modal({
  wagmiConfig,
  projectId,
  enableAnalytics: false,
  enableOnramp: false,
  themeVariables: {
    '--w3m-font-family': "'Sora', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  },
})
